/**
 * The only module that touches `document.cookie`.
 *
 * Isolating it here lets consentStore be unit-tested in a plain Node
 * environment with a fake jar, so the test suite needs no DOM implementation.
 */

export const browserCookies = {
  get() {
    return typeof document === 'undefined' ? '' : document.cookie;
  },
  set(value) {
    if (typeof document !== 'undefined') {
      document.cookie = value;
    }
  },
};
